document.addEventListener('DOMContentLoaded', () => {

  // Beast/Doubly Currency Converter: round displayed prices in every currency
  // (EUR included) UP to the next multiple of 10 (e.g. 100.25 -> 110). This is
  // display-only: checkout still charges the exact price.
  // Doubly stores the precise converted amount (in cents) on a per-currency
  // attribute, e.g. doubly-currency-usd="72876.75", separate from the
  // (truncated) text it renders, so we round from that raw value.
  (function () {
    function reformatPrice(el) {
      const code = (el.getAttribute('doubly-currency') || 'EUR').toUpperCase();

      const rawAttr = el.getAttribute(`doubly-currency-${code.toLowerCase()}`);
      if (!rawAttr) return;

      const rawMajor = parseFloat(rawAttr) / 100;
      if (Number.isNaN(rawMajor)) return;

      const roundedMajor = Math.ceil(Math.round(rawMajor * 100) / 1000) * 10;

      if (el.dataset.roundedCurrency === code && el.dataset.roundedValue === String(roundedMajor)) return;

      const originalText = el.textContent.trim();
      const numMatch = originalText.match(/[\d](?:[\d.,'\s ]*[\d])?/);
      if (!numMatch) return;

      const prefix = originalText.slice(0, numMatch.index);
      const suffix = originalText.slice(numMatch.index + numMatch[0].length);

      const decMatch = numMatch[0].match(/([.,])(\d{2})$/);
      const decimalSep = decMatch ? decMatch[1] : null;
      const thousandSep = decimalSep === '.' ? ',' : decimalSep === ',' ? '.' : null;

      let intPart = String(Math.round(roundedMajor));
      if (thousandSep) {
        intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
      }
      const formattedNum = decimalSep ? `${intPart}${decimalSep}00` : intPart;

      el.dataset.roundedCurrency = code;
      el.dataset.roundedValue = String(roundedMajor);
      el.textContent = `${prefix}${formattedNum}${suffix}`;
    }

    function reformatAll() {
      document.querySelectorAll('.money[doubly-currency-eur]').forEach(reformatPrice);
    }

    reformatAll();

    let scheduled = false;
    const scheduleReformat = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        reformatAll();
      });
    };

    new MutationObserver(scheduleReformat).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['doubly-currency'],
    });
  })();

  /**
   * HeaderMenuDrawer
   * header-menu-drawer
   */

  // Fade out sub panels before the drawer closes.
  // Intercept the close button click in capture phase, fade panels, then re-trigger after delay.
  const menuDrawer = document.querySelector('header-menu-drawer');
  if (menuDrawer) {
    let skipInterception = false;

    document.addEventListener('click', (e) => {
      if (skipInterception) return;

      const trigger = e.target.closest('[aria-controls="menu-drawer"]');
      if (!trigger) return;
      if (!menuDrawer.hasAttribute('open')) return;

      const activePanels = Array.from(menuDrawer.querySelectorAll('header-menu-drawer-panel.active'));
      if (activePanels.length === 0) return;

      e.stopImmediatePropagation();
      e.preventDefault();

      activePanels.forEach(p => p.classList.remove('active', 'switching'));

      setTimeout(() => {
        skipInterception = true;
        trigger.click();
        requestAnimationFrame(() => { skipInterception = false; });
      }, 250);

    }, true); // capture phase — runs before DialogElement's listener
  }



  /**
   * HeaderMenuDrawerPanel
   * header-menu-drawer-panel
   */

  if (document.querySelectorAll('header-menu-drawer-panel').length > 0) {
    const headerMenuDrawerPanel = document.querySelectorAll('header-menu-drawer-panel');
    const headerMenuDrawerPanelButtons = document.querySelectorAll('header-menu-drawer-panel button[data-panel-toggle]');

    headerMenuDrawerPanelButtons.forEach(element => {
      element.addEventListener('click', (e) => {
        const panelAnchor = e.currentTarget.getAttribute('aria-controls');
        const panel = document.querySelector(`header-menu-drawer-panel#${panelAnchor}`);
        if (!panel) return;

        const isThirdLevel = panel.classList.contains('third_level');
        const activePanelSelector = isThirdLevel
          ? 'header-menu-drawer-panel.third_level.active'
          : 'header-menu-drawer-panel.second_level.active';

        const activePanels = Array.from(document.querySelectorAll(activePanelSelector));

        if (activePanels.length > 0) {
          // Switching same level:

          // 1. Fade out any open third level panel
          if (!isThirdLevel) {
            document.querySelectorAll('header-menu-drawer-panel.third_level.active').forEach(p => {
              p.classList.remove('active', 'switching');
            });
          }

          // 2. Add switching FIRST — incoming background becomes instantly visible (opacity:1, transition:none)
          panel.classList.add('switching');

          // 3. NOW snap outgoing to hidden (incoming bg is already covering it)
          activePanels.forEach(p => {
            p.style.transition = 'none';
            p.classList.remove('active', 'switching');
          });

          // 4. Force reflow so browser registers content at opacity:0 before active is added
          panel.getBoundingClientRect();

          // 5. Add active: content fades in
          panel.classList.add('active');

          // 6. Restore outgoing transitions after frame
          requestAnimationFrame(() => {
            activePanels.forEach(p => p.style.removeProperty('transition'));
          });

          // 7. Clean up switching after content fade completes
          setTimeout(() => panel.classList.remove('switching'), 450);

        } else {
          // New level: whole panel fades in
          panel.classList.add('active');
        }
      });
    });
  }



  /**
   * Chiusura pannelli quando viene chiuso il menu
   */

  const menuButton = document.querySelector('[aria-controls="menu-drawer"]');
  const headerMenuDrawerPanel = document.querySelectorAll('header-menu-drawer-panel');

  if ( menuButton && headerMenuDrawerPanel.length > 0 ) {

    const menuBtnObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes') {
          if (menuButton.getAttribute(mutation.attributeName) === "true") {
            console.log(menuButton.getAttribute(mutation.attributeName));
            let activePanels = document.querySelectorAll("header-menu-drawer-panel.active");
            activePanels.forEach(element => {
              element.classList.remove('active', 'leaving', 'switching');
            });
          }
        }
      });
    });

    menuBtnObserver.observe(menuButton, {
      attributes: true,
      attributeOldValue: true // optional, gives old value
    });

  }


// APertura menu al clic della voce Collezioni dell'header (DA QUI NON FUNZIONA)
(function () {
  const menuItems = document.querySelectorAll('.top-menu .menu-item');
  const hamburger = document.querySelector('.header__primary-nav button.tap-area');

  if (menuItems.length < 2 || !hamburger) return;

  const firstItem = menuItems[0];
  const secondItem = menuItems[1];

  // Se è un link, evita che navighi via prima dello switch panel
  firstItem.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    // 1) Apri drawer se è chiuso
    const expanded = hamburger.getAttribute('aria-expanded') === 'true';
    if (!expanded) hamburger.click();

    // 2) Aspetta che il bottone del panel 2 esista, poi cliccalo
    const selector = 'header-menu-drawer-panel button[aria-controls="menu-drawer-panel-1"]';

    const start = Date.now();
    const timer = setInterval(() => {
      const btn = document.querySelector(selector);

      console.log(btn);

      if (btn) {
        clearInterval(timer);
        btn.click();
        return;
      }

      // safety stop dopo 2.5s
      if (Date.now() - start > 2500) {
        clearInterval(timer);
        console.warn('[drawer] bottone panel 2 non trovato:', selector);
      }
    }, 50);
  });

  secondItem.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    // 1) Apri drawer se è chiuso
    const expanded = hamburger.getAttribute('aria-expanded') === 'true';
    if (!expanded) hamburger.click();

    // 2) Aspetta che il bottone del panel 2 esista, poi cliccalo
    const selector = 'header-menu-drawer-panel button[aria-controls="menu-drawer-panel-2"]';

    const start = Date.now();
    const timer = setInterval(() => {
      const btn = document.querySelector(selector);

      if (btn) {
        clearInterval(timer);
        btn.click();
        return;
      }

      // safety stop dopo 2.5s
      if (Date.now() - start > 2500) {
        clearInterval(timer);
        console.warn('[drawer] bottone panel 2 non trovato:', selector);
      }
    }, 50);
  });
})();

document.querySelectorAll('.top-menu .menu-item')[1]?.addEventListener('click', () => console.log('CLICK OK'));


/**
 * Back to parent level on click ".menu-drawer__panel-level"
 * Gestione coerente con la tua logica: class "active" su header-menu-drawer-panel
 */
document.addEventListener('click', (e) => {
  const backEl = e.target.closest('.menu-drawer__panel-level');
  if (!backEl) return;

  e.preventDefault();
  e.stopPropagation();

  const currentPanel = backEl.closest('header-menu-drawer-panel');
  if (!currentPanel) return;

  // Caso 1: sono in un pannello di terzo livello -> torno al livello precedente (secondo livello)
  if (currentPanel.classList.contains('third_level')) {
    currentPanel.classList.remove('active');

    // Provo a riattivare l'ultimo pannello attivo NON third_level (secondo livello)
    const parentCandidate = Array.from(
      document.querySelectorAll('header-menu-drawer-panel.active:not(.third_level)')
    ).pop();

    if (parentCandidate) {
      parentCandidate.classList.add('active');
    } else {
      // fallback: nessun parent trovato -> chiudo tutti i pannelli (torno al root)
      document
        .querySelectorAll('header-menu-drawer-panel.active')
        .forEach(p => p.classList.remove('active'));
    }

    return;
  }

  // Caso 2: sono in un pannello "normale" (secondo livello) -> torno al root (chiudo tutti)
  document
    .querySelectorAll('header-menu-drawer-panel.active')
    .forEach(p => p.classList.remove('active'));
});


// NOTA: in precedenza qui veniva rimossa la classe "money"/l'attributo "doubly-currency"
// dai prezzi in mini-cart e main cart per impedire la conversione valuta di Beast
// Converter. Questo impediva anche a Beast di formattare/convertire i prezzi in quelle
// aree (simbolo mancante, valuta che non cambiava). Rimosso per lasciare che Beast
// Converter gestisca i prezzi di mini-cart e main cart come nel resto del sito.



  // Inserisce classe per aprire popup form
  // const observedElements = new Set();

  // const intersectionObserver = new IntersectionObserver(function (entries) {
  //   entries.forEach(function (entry) {
  //     if (entry.isIntersecting) {
  //       entry.target.classList.add('hulk-popup-trigger');
  //     } else {
  //       entry.target.classList.remove('hulk-popup-trigger');
  //     }
  //   });
  // }, {
  //   root: null,
  //   threshold: 0.2
  // });

  // function observeMatchingElements() {
  //   const elements = document.querySelectorAll('a, button');

  //   elements.forEach(function (el) {
  //     const text = el.textContent.replace(/\s+/g, ' ').trim().toLowerCase();

  //     if (text === 'contattaci' && !observedElements.has(el)) {
  //       observedElements.add(el);
  //       intersectionObserver.observe(el);
  //     }
  //   });
  // }

  // observeMatchingElements();

  // const mutationObserver = new MutationObserver(function () {
  //   observeMatchingElements();
  // });

  // mutationObserver.observe(document.body, {
  //   childList: true,
  //   subtree: true
  // });


  // Popup custom


//   document.addEventListener('DOMContentLoaded', function () {
//   const popup = document.getElementById('hulk-custom-popup');
//   if (!popup) return;

//   const openButtons = document.querySelectorAll('.open-hulk-popup');
//   const closeButtons = popup.querySelectorAll('[data-close-popup]');
//   const dialog = popup.querySelector('.hulk-custom-popup__dialog');

//   function openPopup() {
//     popup.classList.add('is-open');
//     popup.setAttribute('aria-hidden', 'false');
//     document.body.classList.add('hulk-popup-open');
//   }

//   function closePopup() {
//     popup.classList.remove('is-open');
//     popup.setAttribute('aria-hidden', 'true');
//     document.body.classList.remove('hulk-popup-open');
//   }

//   openButtons.forEach(function (button) {
//     button.addEventListener('click', function (event) {
//       event.preventDefault();
//       openPopup();
//     });
//   });

//   closeButtons.forEach(function (button) {
//     button.addEventListener('click', function () {
//       closePopup();
//     });
//   });

//   document.addEventListener('keydown', function (event) {
//     if (event.key === 'Escape' && popup.classList.contains('is-open')) {
//       closePopup();
//     }
//   });

//   popup.addEventListener('click', function (event) {
//     if (!dialog.contains(event.target)) {
//       closePopup();
//     }
//   });
// });

//  Mappatura cta form

// Cta pagine generiche 
  const btnA = document.querySelectorAll('.contatti-cta');

btnA.forEach(el => {
  el.addEventListener('click', function (e) {
    const parentBtn = e.target.closest('button, a');

    if (!parentBtn) return;

    e.preventDefault();
    e.stopPropagation();

    let lang = 'it';
    const path = window.location.pathname;

    if (path.startsWith('/en')) lang = 'en';
    else if (path.startsWith('/fr')) lang = 'fr';
    else if (path.startsWith('/de')) lang = 'de';
    else if (path.startsWith('/es')) lang = 'es';

    const popupBtnMap = {
      it: '#FBpopupbtn-nxhtBSAr1U7JN0xJOAxDlQ',
      en: '#FBpopupbtn-2GpA_DINO6NDm0Vnan0-NA',
      fr: '#FBpopupbtn-ZKIgL1jnv_Hx6341fHBmlg',
      de: '#FBpopupbtn-ZdY0o4W6hP4cXELLJtEQdQ',
      es: '#FBpopupbtn-x5nxMV4PQlnB_ONA6EXC4w'
    };

    const targetBtn = document.querySelector(popupBtnMap[lang] || popupBtnMap.it);

    targetBtn?.click();
  });
});



// Cta pagina PRDOTTO 
//   const btnProductA = document.querySelectorAll('.product-custom-cta');

// btnProductA.forEach(el => {
//   el.addEventListener('click', function (e) {
//     const parentProductBtn = e.target.closest('button, a');

//     if (!parentProductBtn) return;

//     e.preventDefault();
//     e.stopPropagation();

//     console.log("button premutooooo");

//     let lang = 'it';
//     const path = window.location.pathname;

//     if (path.startsWith('/en')) lang = 'en';
//     else if (path.startsWith('/fr')) lang = 'fr';
//     else if (path.startsWith('/de')) lang = 'de';
//     else if (path.startsWith('/es')) lang = 'es';

//     const popupBtnProductMap = {
//       it: '#FBpopupbtn-ZSrgjygluetakNVu7KzafQ',
//       en: '#FBpopupbtn-9EOfzF_2S5pJJzViXbx4Pw',
//       fr: '#FBpopupbtn-ID-FRANCESE',
//       de: '#FBpopupbtn-ID-TEDESCO',
//       es: '#FBpopupbtn-ID-SPAGNOLO'
//     };

//     const targetProductBtn = document.querySelector(popupBtnProductMap[lang] || popupBtnProductMap.it);

//     targetProductBtn?.click();
//   });
// });

  // Reset product gallery to first image on variant change
  document.addEventListener('variant:change', (event) => {
    const form = event.target;
    const formId = form.getAttribute ? form.getAttribute('id') : null;

    if (formId) {
      const gallery = document.querySelector(`product-gallery[form="${formId}"]`);

      if (gallery && gallery.carousel) {
        const firstVisibleCell = Array.from(gallery.carousel.cells).find(cell => {
          return !cell.hasAttribute('hidden');
        });

        if (firstVisibleCell) {
          const firstVisibleIndex = Array.from(gallery.carousel.cells).indexOf(firstVisibleCell);
          gallery.carousel.select(firstVisibleIndex, { instant: true });
        }
      }
    }
  }, true);

}); // === DOMContentLoaded ===
